import { render, staticRenderFns } from "./LeavingPrivate.vue?vue&type=template&id=efbaf67e&scoped=true&"
import script from "./LeavingPrivate.vue?vue&type=script&lang=ts&"
export * from "./LeavingPrivate.vue?vue&type=script&lang=ts&"
import style0 from "./LeavingPrivate.vue?vue&type=style&index=0&id=efbaf67e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efbaf67e",
  null
  
)

export default component.exports